import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageTitle } from "../components/PageTitle";
import { getBlogs } from "../api/blogs";
import { getImageUrl } from "../api/utils";

const BlogsList = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    loadBlogs(1);
  }, []);

  const loadBlogs = async (page) => {
    page === 1 ? setLoading(true) : setLoadingMore(true);
    try {
      const res = await getBlogs(page);
      const newBlogs = res?.blogs || [];
      setBlogs((prev) => (page === 1 ? newBlogs : [...prev, ...newBlogs]));
      const totalPages = res?.pagination?.total_pages || 1;
      setHasMore(page < totalPages);
      setCurrentPage(page);
    } catch (e) {
      console.error("Failed to load blogs", e);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  return (
    <>
      <PageTitle
        title="Blogs"
        subtitle="Stories From The Hop!"
        bgImage="blogBanner.png"
      />

      <div className="blog-grid-main">
        <div className="container">
          {/* Loading Skeleton */}
          {loading && (
            <div className="row">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="col-xl-4 col-md-6 col-12">
                  <div className="blog-article-item">
                    <div
                      style={{
                        background: "#f4f3ef",
                        height: 260,
                        marginBottom: 12,
                        borderRadius: 4,
                        animation: "pulse 1.4s ease-in-out infinite",
                      }}
                    />
                    <div
                      style={{
                        background: "#f4f3ef",
                        height: 18,
                        width: "70%",
                        marginBottom: 8,
                        animation: "pulse 1.4s ease-in-out infinite",
                      }}
                    />
                    <div
                      style={{
                        background: "#f4f3ef",
                        height: 14,
                        width: "40%",
                        animation: "pulse 1.4s ease-in-out infinite",
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Empty State */}
          {!loading && blogs.length === 0 && (
            <div style={{ textAlign: "center", padding: "60px 0" }}>
              <p style={{ color: "#888", fontSize: 15 }}>
                No blogs found. Check back soon! 🌈
              </p>
            </div>
          )}

          {/* Blog Cards Grid */}
          {!loading && blogs.length > 0 && (
            <div className="row">
              {blogs.map((blog) => (
                <div key={blog.id} className="col-xl-4 col-md-6 col-12">
                  <div className="blog-article-item">
                    {/* Thumbnail */}
                    <div className="article-thumb">
                      <Link to={`/blogs/${blog.slug}`}>
                        <img
                          className="lazyload"
                          src={getImageUrl(blog.banner_image)}
                          alt={blog.title}
                        />
                      </Link>
                      {/* Category Label — show first category if available */}
                      {blog.category && (
                        <div className="article-label">
                          <Link
                            to={`/blogs/${blog.slug}`}
                            className="tf-btn btn-sm radius-3 btn-fill animate-hover-btn"
                          >
                            {blog.category}
                          </Link>
                        </div>
                      )}
                    </div>

                    {/* Content */}
                    <div className="article-content">
                      <div className="article-title">
                        <Link to={`/blogs/${blog.slug}`}>{blog.title}</Link>
                      </div>
                      <div className="article-btn">
                        <Link
                          to={`/blogs/${blog.slug}`}
                          className="tf-btn btn-line fw-6"
                        >
                          Read more
                          <i className="icon icon-arrow1-top-left" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Load More Button */}
          {!loading && hasMore && (
            <div style={{ textAlign: "center", padding: "32px 0" }}>
              <button
                onClick={() => loadBlogs(currentPage + 1)}
                disabled={loadingMore}
                className="tf-btn btn-fill animate-hover-btn"
                style={{
                  opacity: loadingMore ? 0.7 : 1,
                  cursor: loadingMore ? "not-allowed" : "pointer",
                }}
              >
                {loadingMore ? "Loading..." : "Load More"}
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default BlogsList;
